var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverableImageButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 7 20)",
    fill: "url(#a)",
    d: "M7 20h7v20H7z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.00357 .00125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 800,
    height: 800,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAMgBAMAAAApXhtbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAFVBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAADtBGx6AAAABnRSTlMA/QMeIX+WKsunAAADzklEQVR42u3c0UnDUBSA4VJdoCB5Dk7QJ58doSuk2rv/CLqAQgKxv+X7RjiHP70Xkh4OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPDgjkbQMs9mkArk6WYIqUDexsUUSoGMSSKpQJZFIq1AJNIKZAyJtAIZEmkFIpFaIBKJBSKRWiASiQUikVogEokFIpFaIBKJBSKRWiASiQUikVogEokFIpFaIBKJBSKRWiBjma5GEwrku5D32Ww6gYzpw1uMAkEg/yaQs0BSgXwKRCAIRCA4YrmDIBCBIBBHLNxBBCIQgSAQRyzcQQSCQASCI5ZA3EEEgkAEgiOWOwgCEQgCEYgjljsIAhEIAnHEwh1EIAhEIDhiCcQdRCAIRCA4YrmD4BdEIAhEIAIRCAIRCAIRCAIRCAIRiEAEgkAEgkAEgkAEgkAEIhCBIBCBIBCBIBCBIBCBIBCBCEQgCEQgCEQgCEQgCEQgAhEIAhEIAhEI+wZyNppSIONFIPvNfH0gY5wGe1nm9YEsFrKjDYGME7sZ6wNhzyfW2BAId1mIQGILEUhrIQKJLUQgrYUIJLYQgbQWIpDYQgTSWohAaoUIJLWQ47NALIRfHlmvHll+1HHsdTFk60IkUluIRGILkUhtIRKJLUQitYVIJLYQidQWIpHYQn5OZPHG5z1eJZXIXWz4HMHb73s+s+b1iSw+2LnTBzs+afPRJ1u++jz5LFoi+OcAiSARiSARiSARiUhEIkhEIkhEIkhEIkhEIhKRCBKRCBKRCBKRCBKRiEQkgkQkgkQkgkQkgkQkIhGJIBGJIBGJIBGJIBGJSEQiSEQiSEQiSEQiSEQiEpEIEpEIEpEIEpEIEpGIRCSCRCSCRCSCRCSCRCQiEYkgEYkgEYkgEYkgEYlIRCJIRCJIRCJIRCJIRCISkQgSkQgSkQh/lYjRtBK5Gk0pkWVcTKaUyHTzG1JKRCCxRKabsZQSEUgsEYG0EhFILBGBtBIRSCwRgbQSEUgsEYG0EhFILBGBtBIRSCwRgbQSEUgsEYG0EhFILRGBtBIRSCwRgcQSmc2glYhXTQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADggXwBf9OhEG5NGjUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverableImageButtonIcon);
export default __webpack_public_path__ + "static/media/hoverable-image-button-icon.851f909978168d6b164af91f91eb365d.svg";
export { ForwardRef as ReactComponent };